 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-010fc414":"bcab84c9","chunk-054f07ee":"01897460","chunk-060efaa3":"a89e52a6","chunk-064bb92d":"bea953da","chunk-06fac3cb":"735a5b36","chunk-0a498f8b":"9491750d","chunk-0b092fc0":"2657f8ce","chunk-0c9a76f2":"23fbc9a0","chunk-101e5f80":"c773a08e","chunk-158e8bbc":"532a96b6","chunk-166c18a3":"51c83dcc","chunk-179272cc":"8b4e0c60","chunk-1b8788b8":"f46bb2b1","chunk-1bdb29c4":"5dff21ee","chunk-21cb7b55":"f82e3201","chunk-3341d4e1":"27d7bdf9","chunk-3edd33f5":"1128b0a5","chunk-19e9da63":"07a72dd7","chunk-23747f90":"009a0bfe","chunk-275c80ba":"d29c782a","chunk-28343789":"13b1e969","chunk-2c43d4da":"f4430c64","chunk-2cea608c":"2dffa575","chunk-2ee98430":"7c1863a1","chunk-30c902cb":"66cce813","chunk-33eaa287":"f899f05a","chunk-35d1b984":"45785dc6","chunk-3c22c23a":"77a44768","chunk-32f6312c":"2c447ac4","chunk-34bf611a":"13d8415f","chunk-4b9d7590":"388e4991","chunk-6445074a":"79ddbcb3","chunk-6a03dd19":"e61729fa","chunk-cfc9efb6":"8155a1a1","chunk-3e6c8184":"8b233fec","chunk-3f8d6ef7":"36b02ddb","chunk-40149cd8":"6a044db2","chunk-418c5b3a":"d7eb381b","chunk-439af7db":"6d9409d6","chunk-453732c6":"7d554d25","chunk-48a0df4e":"47aaeaff","chunk-57167524":"f61ef882","chunk-5a79174b":"e829066c","chunk-5ab0508d":"8fb7f31d","chunk-5f55ff10":"2f6c37d3","chunk-69997f8e":"9b79fe5f","chunk-6ac4382e":"6acac5b8","chunk-6ae2407a":"3bede2a4","chunk-71a8468a":"2afe88f3","chunk-7907bdd7":"3004ff71","chunk-7a86740c":"6c2e731f","chunk-7afce00b":"74dc4f36","chunk-7d589856":"d120f592","chunk-80d2c85c":"ef1ebd8d","chunk-8258ae28":"8e0d5616","chunk-82fad47c":"9cd1aac8","chunk-846f192c":"2c9636a9","chunk-8cc2095c":"cc437e2e","chunk-8efd165a":"7d4945e8","chunk-8f2e7d8c":"06abb301","chunk-91ee8324":"0cdc7bf2","chunk-aaf237e4":"1cb63839","chunk-b1ddea06":"9cc230c0","chunk-b265e91a":"24c89182","chunk-b9b9d912":"8a858f4f","chunk-be609cb8":"1201f145","chunk-bf4f5036":"30142e46","chunk-bfff34fc":"7d0687c4","chunk-d20656ea":"e5d35128","chunk-f478b624":"35cc16a3","chunk-f4f35b38":"f9084507","chunk-fa47e44a":"3d3d1937"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-010fc414":1,"chunk-054f07ee":1,"chunk-064bb92d":1,"chunk-06fac3cb":1,"chunk-0a498f8b":1,"chunk-0b092fc0":1,"chunk-0c9a76f2":1,"chunk-101e5f80":1,"chunk-158e8bbc":1,"chunk-166c18a3":1,"chunk-179272cc":1,"chunk-1b8788b8":1,"chunk-1bdb29c4":1,"chunk-3341d4e1":1,"chunk-19e9da63":1,"chunk-23747f90":1,"chunk-275c80ba":1,"chunk-28343789":1,"chunk-2c43d4da":1,"chunk-2cea608c":1,"chunk-2ee98430":1,"chunk-30c902cb":1,"chunk-33eaa287":1,"chunk-35d1b984":1,"chunk-32f6312c":1,"chunk-34bf611a":1,"chunk-4b9d7590":1,"chunk-6445074a":1,"chunk-6a03dd19":1,"chunk-cfc9efb6":1,"chunk-3e6c8184":1,"chunk-3f8d6ef7":1,"chunk-40149cd8":1,"chunk-418c5b3a":1,"chunk-439af7db":1,"chunk-453732c6":1,"chunk-48a0df4e":1,"chunk-57167524":1,"chunk-5a79174b":1,"chunk-5ab0508d":1,"chunk-5f55ff10":1,"chunk-69997f8e":1,"chunk-6ac4382e":1,"chunk-6ae2407a":1,"chunk-71a8468a":1,"chunk-7907bdd7":1,"chunk-7a86740c":1,"chunk-7afce00b":1,"chunk-7d589856":1,"chunk-80d2c85c":1,"chunk-8258ae28":1,"chunk-82fad47c":1,"chunk-846f192c":1,"chunk-8cc2095c":1,"chunk-8efd165a":1,"chunk-8f2e7d8c":1,"chunk-91ee8324":1,"chunk-aaf237e4":1,"chunk-b1ddea06":1,"chunk-b265e91a":1,"chunk-b9b9d912":1,"chunk-be609cb8":1,"chunk-bf4f5036":1,"chunk-bfff34fc":1,"chunk-d20656ea":1,"chunk-f478b624":1,"chunk-f4f35b38":1,"chunk-fa47e44a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-010fc414":"7df40c23","chunk-054f07ee":"9ab3e433","chunk-060efaa3":"31d6cfe0","chunk-064bb92d":"5ba3bd30","chunk-06fac3cb":"446a3a36","chunk-0a498f8b":"adbd4436","chunk-0b092fc0":"a22ec85b","chunk-0c9a76f2":"e20ffbce","chunk-101e5f80":"07394e47","chunk-158e8bbc":"eefc116a","chunk-166c18a3":"2569b80e","chunk-179272cc":"2dae4caf","chunk-1b8788b8":"fa9888b1","chunk-1bdb29c4":"b67b495d","chunk-21cb7b55":"31d6cfe0","chunk-3341d4e1":"70f246b0","chunk-3edd33f5":"31d6cfe0","chunk-19e9da63":"e0bf7181","chunk-23747f90":"5f296a76","chunk-275c80ba":"f2d1cf23","chunk-28343789":"b94e9ef6","chunk-2c43d4da":"ffaf79ef","chunk-2cea608c":"10559439","chunk-2ee98430":"37ecddc7","chunk-30c902cb":"0cb64049","chunk-33eaa287":"8a88b0e7","chunk-35d1b984":"e3885289","chunk-3c22c23a":"31d6cfe0","chunk-32f6312c":"c5c6085b","chunk-34bf611a":"84c7b77f","chunk-4b9d7590":"44d62cbf","chunk-6445074a":"312e7a1d","chunk-6a03dd19":"80f536e7","chunk-cfc9efb6":"28528240","chunk-3e6c8184":"8357d08c","chunk-3f8d6ef7":"2eca087a","chunk-40149cd8":"d4f956cb","chunk-418c5b3a":"c23d4e5b","chunk-439af7db":"4283ad93","chunk-453732c6":"7aaa9083","chunk-48a0df4e":"83906db4","chunk-57167524":"9a558787","chunk-5a79174b":"7e157fd3","chunk-5ab0508d":"e492054b","chunk-5f55ff10":"df50119c","chunk-69997f8e":"840da21f","chunk-6ac4382e":"9390bcaf","chunk-6ae2407a":"cb66634e","chunk-71a8468a":"a72b6c74","chunk-7907bdd7":"b66704be","chunk-7a86740c":"060d2bf6","chunk-7afce00b":"30bc85d3","chunk-7d589856":"0aa1543d","chunk-80d2c85c":"5ecbc8a8","chunk-8258ae28":"8fb6e227","chunk-82fad47c":"f6c703e8","chunk-846f192c":"af447292","chunk-8cc2095c":"dcf92ea4","chunk-8efd165a":"38241816","chunk-8f2e7d8c":"d81ba25b","chunk-91ee8324":"0e433876","chunk-aaf237e4":"00738499","chunk-b1ddea06":"f60fdac6","chunk-b265e91a":"aa42c907","chunk-b9b9d912":"d160614a","chunk-be609cb8":"4f4ceb7c","chunk-bf4f5036":"4163a728","chunk-bfff34fc":"7c3c0590","chunk-d20656ea":"3c61a393","chunk-f478b624":"0425a33c","chunk-f4f35b38":"4fb36c5f","chunk-fa47e44a":"0d2bbb4a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://tc-nj-backend-ms-pub-cdn.mobvoi.com/voice-maker-h5-prd/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vant","chunk-libs"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
